<template>
  <div>
    <h2>Dateikategorien</h2>
    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>Bezeichnung</th>
      </tr>
      </thead>
    </table>
  </div>

</template>

<script>
/* global $ */

export default {
  name: 'Filecategory',
  data () {
    return {
      // eslint-disable-next-line no-undef
      tableId: 'dTable_' + this.$func.uuid()
    }
  },
  computed: {},
  async mounted () {
    var tableId = this.tableId
    var self = this
    var path = '/basedata/filecategory/'

    this.$func.loadDatatable(
      () => $(document).ready(function () {
        var editor = new $.fn.dataTable.Editor({
          ajax: {
            create: self.$func.addAuth({
              type: 'POST',
              url: path
            }),
            edit: self.$func.addAuth({
              type: 'PUT',
              url: path + '_id_/'
            }),
            remove: self.$func.addAuth({
              type: 'DELETE',
              url: path + '_id_/',
              deleteBody: false
            })
          },
          idSrc: 'id',
          table: '#' + tableId,
          fields: [{
            label: 'Bezeichnung:',
            name: 'sBezeichnung'
          }
          ]
        })

        $('#' + tableId).DataTable({
          dom: 'Bfrtip', // BUTTON/FIND/PROCESSING/TABLE/INFO/PAGING
          ajax: self.$func.addAuth({
            url: path,
            type: 'GET'
          }),
          scrollX: true,
          scrollCollapse: true,
          columns: [
            {
              class: 'center',
              data: 'sBezeichnung'
            }
          ],
          buttons: self.$func.addDefaultButtons([
            {
              extend: 'create',
              editor: editor
            },
            {
              extend: 'edit',
              editor: editor
            },
            {
              extend: 'remove',
              editor: editor
            }
          ])
        })

        $('#' + tableId + ' tbody').on('dblclick', 'tr', function () {
          editor
            .edit(this)
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons({
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            })
        })
      }))
  }
}
</script>
<style>

</style>
